//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

import { LocalDictionaryFactory } from '../../api/api.module'
import { ColumnModel } from '../../api/api.models'

import { ActionStatusOptions } from '../../common/action-status/action-status.controller'
import { ActionRunController } from '../../common/action-run/action-run.controller'
import { DetailsPopupOptions, DetailsOptions, } from '../../common/details-popup/details-popup.directive'
import { DetailsScope, Details, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { GridController, GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { InfoPopupSource } from '../../common/info-popup/info-popup.directive'
import { LoggerService } from '../../common/common.module'
import { TreeListOptions } from '../../common/tree-list/tree-list.controller'

import { CommonHelper, ConfigHelper, ConvertHelper, EventsNames, LocalizationHelper, OperatorLayoutSettings, TemplateHelper, ToastHelper, TypeHelper } from '../../../helpers/'
import { ActionHelper } from '../../../helpers/action-helper'

import { DeviceService } from '../../../services/device'
import { DepositoryService, DepositoryMinStatesService, MinStateItem } from '../../../services/depository'
import { UserSessionService } from '../../../services/user-session'

import { Activity, Enums } from '../../../models/common/'
import { OpData, OpDevice, OpLocation, OpLocationEquipment } from '../../../models/core/'
import { SESSION } from '../../../models/custom/session'

import { GridBridge } from '../../common/common.interfaces'

import { DepositoryHelper } from '../depositories.helper'
import { ItemSwapperPopupOptions, IItemSwapperPopup, ItemSwapperResult } from '../../../modules/common/item-swapper'
import { IMRDepositoryParametersOptions } from '../../common/depository-parameters'
import { ColumnInfo } from '../../../models/custom'
import { CreateEditResult } from '../../../services/system'
import { IIMRDepositoryParameters, IMRDepositoryParametersInitializedArgs } from '../../../modules/common/depository-parameters/depository-parameters.interfaces'


export interface DepositoryDetailsScope extends DetailsScope {
    ACTION_RUN_POPUP_ID: string
    ACTION_STATUS_POPUP_ID: string
    INFO_POPUP_ID: string
    ITEM_SWAPPER_POPUP_ID: string
    DELETE_CONFIRMATION_POPUP_ID: string
    RE_USE_CONFIRMATION_POPUP_ID: string

    id: number
    popupId: number

    treeListOptions: TreeListOptions
    infoPopupSource: InfoPopupSource
    contentGridOptions: GridOptions

    needInfoPopup: boolean
    needActionRun: boolean

    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }

    reUseConfirmation: {
        title: string

        onConfirmed: () => void
    }

    itemSwapperPopupOptions: ItemSwapperPopupOptions<OpLocationEquipment>
}

export class DepositoryDetailsDirectiveController extends Details<DepositoryDetailsScope> {

    //#region Consts

    public get DEPOSITORY_CONTENT_ACCORDION_NAME(): string { return 'DEPOSITORY_CONTENT_ACCORDION_NAME' }
    public get DEPOSITORY_PARAMS_ACCORDION_NAME(): string { return 'DEPOSITORY_PARAMS_ACCORDION_NAME' }
    public get DEPOSITORY_COMMON_TAB_NAME(): string { return 'DEPOSITORY_COMMON_TAB_NAME' }
    public get DEPOSITORY_MINIMUM_STATE_ACCORDION_NAME(): string { return 'DEPOSITORY_MINIMUM_STATE_ACCORDION_NAME' }

    private get MIN_STATE_GRID_NAME(): string { return 'DEPOSITORY_MIN_STATE_GRID_NAME' }
    private get MIN_STATE_GRID_EDIT_NAME(): string { return 'MIN_STATE_GRID_EDIT_NAME' }
    private get MIN_STATE_GRID_EDIT_POPUP_ID(): string { return this.$scope.detailsPopupId + '_MIN_STATE_GRID_EDIT_POPUP' }
    private get DEPOSITORY_MIN_STATE_COLUMN_NAME(): string { return 'amount' }
    //#endregion


    //#region Members

    public minStateGridOptions: GridOptions
    public minStateGridEditOptions: GridBridge

    private configurationConsistencyCheckButton: DevExpress.ui.dxButton
    private contentGrid: GridController<OpLocationEquipment>
    private depository: OpLocation
    private devicesInDepositoryCount: number
    private inventory: OpLocationEquipment[] = []
    private itemSwapperPopup: IItemSwapperPopup<OpLocationEquipment>
    private minStatesCount: number
    private minStatesGrid: GridController<MinStateItem>
    private referenceObject: OpLocation
    private referenceObjectId: number
    private selectedDevices: OpDevice[]
    private sendConfigurationToDeviceButton: DevExpress.ui.dxButton

    private depositoryParametersComponent: IIMRDepositoryParameters

    //#endregion


    //#region Ctor

    constructor(
        $scope: DepositoryDetailsScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService,
        private deviceService: DeviceService,
        private depositoryService: DepositoryService,
        private depositoryMinStatesService: DepositoryMinStatesService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.LocationPopupTabActive, userSession, referenceType, moduleName)

        this.setConfirmationsOptions()
        this.setInfoPopup()
        this.setOptions()
        this.setTemplateConsts()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    //#endregion


    //#region Events

    private onDeleted(): void {
        super.markAsDeleted();

        this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
        this.hidePopup()
    }

    private onEdited(location: OpLocation): void {
        super.markAsEdited();

        this.onRefresh(location);
    }

    protected onInitialize(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options

        this.referenceObjectId = options.referenceObjectId

        this.onClear()
        this.showPopup()
        this.onRefresh()
    }

    private onRefresh(toRefresh: OpLocation = null): void {
        const deferred: JQueryDeferred<OpLocation> = $.Deferred<OpLocation>()

        if (!toRefresh) {
            this.userSession
                .getDataProvider().Depository
                .getDepository(this.referenceObjectId)
                .then((result: OpLocation) => {
                    this.$scope.popupTitle = result.toString()

                    deferred.resolve(result)
                })
                .fail((error: any) => {
                    let errorMsg: string = error

                    if (SESSION.isType(error)) {
                        errorMsg = (<SESSION>error).toString()
                    }

                    this.logger.log(errorMsg)

                    deferred.resolve(null)
                })
                .always(() => {
                    this.$scope.showTabs = true
                })
        } else {
            deferred.resolve(toRefresh)
        }

        deferred
            .promise()
            .then((depository: OpLocation) => {
                this.referenceObject = depository
                this.setBasicParameters(depository)
                this.setContentGrid()
                this.initializeMinStates(depository)
            })
    }

    private onParamsEdit(): void {
        this.depositoryService
            .openEditByDepository(this.referenceObjectId, this.referenceObject)
            .then((result: CreateEditResult<OpLocation>) => {
                if (result.status === CreateEditResult.Status.Success) {
                    this.onEdited(result.object)
                }
            });
    }

    private onClear(): void {
        this.$scope.contentGridOptions = null
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false

        this.contentGrid = null
        this.devicesInDepositoryCount = 0
        this.minStateGridEditOptions = null
        this.minStateGridOptions = null
        this.minStatesCount = 0
        this.minStatesGrid = null
        this.referenceObject = null
        this.selectedDevices = []

        this.toggleConfigurationButtons()
    }

    private onConfirmDelete(): void {
        DepositoryHelper
            .deleteDepository(this.userSession.getDataProvider(), this.referenceObjectId)
            .then(() => {
                this.onDeleted();
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.DELETE_CONFIRMATION_POPUP_ID,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onConfirmUseAgain(): void {
        this.userSession.getDataProvider().Depository.useAgainDepositoryElement(this.contentGrid.selectedItems)
            .fail((error: any) => {
                ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error))
            }).always(() => {
                this.onRefresh(this.referenceObject)
            })
    }

    private refreshMap(): void {
        if (this.depositoryParametersComponent != null) {
            this.depositoryParametersComponent.refresh()
        }
    }

    // #endregion


    //#region Parameters

    public depositoryParametersOptions: IMRDepositoryParametersOptions

    private setBasicParameters(depository: OpLocation): void {
        this.depositoryParametersOptions = null

        this.$timeout(() => {
            this.depositoryParametersOptions = {
                depository,
                onInitialized: (e: IMRDepositoryParametersInitializedArgs) => {
                    this.depositoryParametersComponent = e.component
                }
            }
        }, 100)
    }

    //#endregion


    // #region Device Configuration

    private onSendDeviceConfiguration(e: any): void {
        ActionHelper
            .sendDeviceConfiguration(this.userSession.getDataProvider(), this.selectedDevices)
            .then((actionStatusOptions: ActionStatusOptions) => {
                this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.$scope.ACTION_STATUS_POPUP_ID, actionStatusOptions)
            })
    }

    private onGetDeviceConfigurationInconsistency(e: any): void {
        const serialNumbers: number[] = this.selectedDevices.map((item: OpDevice) => item.serialNbr)

        this.userSession
            .getDataProvider().Device
            .getDeviceConfigurationInconsistency(serialNumbers)
            .then((dataList: OpData[]) => {
                this.deviceService
                    .getDeviceConfigurationInconsistencyOptions(this.userSession.getDataProvider(), dataList, serialNumbers)
                    .then((treeOptions: any) => {
                        this.$scope.needInfoPopup = true
                        this.$scope.treeListOptions = treeOptions

                        this.$timeout(() => {
                            this.$scope.$broadcast(EventsNames.OPEN_INFO_POPUP_POPUP + this.$scope.INFO_POPUP_ID, dataList, treeOptions)
                        }, 500)
                    })
                    .fail((error: any) => {
                        CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeviceConfigurationInconsistencyError), 'error', 4000)

                        this.logger.log(error)
                    })
            })
    }

    private toggleConfigurationButtons(): void {
        if (this.configurationConsistencyCheckButton) {
            this.configurationConsistencyCheckButton.option('disabled', this.selectedDevices.length === 0)
        }

        if (this.sendConfigurationToDeviceButton) {
            this.sendConfigurationToDeviceButton.option('disabled', this.selectedDevices.length === 0)
        }
    }

    // #endregion


    // #region Rewarehousing

    private openRewarehousingItemSwapper(): void {
        if (this.itemSwapperPopup != null) {
            this.itemSwapperPopup.itemSwapper.reset()
            this.itemSwapperPopup.show()
        } else {
            this.initializeItemSwapper()
                .then(() => {
                    this.itemSwapperPopup.itemSwapper.reset()
                    this.itemSwapperPopup.show()
                })
        }
    }

    private initializeItemSwapper(): JQueryPromise<void> {
        const defer: JQueryDeferred<void> = $.Deferred<void>()
        this.depositoryService
            .getDefaultRewarehousingItemSwapperOptions()
            .then((options: ItemSwapperPopupOptions<OpLocationEquipment>) => {
                options.onSave = (result: ItemSwapperResult<OpLocationEquipment>) => this.onRewarehousingSave(result)

                options.itemSwapperOptions.leftGridOptions.getDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                    if (this.referenceObjectId != null
                        && this.itemSwapperPopup != null
                        && this.itemSwapperPopup.isVisible()
                    ) {
                        return this.userSession
                            .getDataProvider()
                            .Depository
                            .getDepositoryContentFilter(this.referenceObjectId, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                options.itemSwapperOptions.rightSelectGridOptions.getSelectedItemDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string, idDepository: number) => {
                    if (this.referenceObjectId != null
                        && this.itemSwapperPopup != null
                        && this.itemSwapperPopup.isVisible()
                    ) {
                        return this.userSession
                            .getDataProvider()
                            .Depository
                            .getDepositoryContentFilter(idDepository, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                this.$scope.itemSwapperPopupOptions = options
                this.$scope.itemSwapperPopupOptions.onInitialized = (itemSwapper: IItemSwapperPopup<OpLocationEquipment>) => {
                    this.itemSwapperPopup = itemSwapper
                    defer.resolve(null)
                }
            })
        return defer.promise()
    }


    private onRewarehousingSave(result: ItemSwapperResult<OpLocationEquipment>): JQueryPromise<void> {
        return this.depositoryService
            .saveDepositoryEquipment(this.referenceObjectId, result)
            .fail((error: any) => {
                this.logger.log(error)
            })
            .always(() => {
                this.onRefresh(this.referenceObject)
            });
    }

    // #endregion


    // #region Content Grid 

    private onContentGridDataReady(locationEquipment: OpLocationEquipment[]): void {
        if (this.contentGrid != null) {
            setTimeout(() => {
                this.devicesInDepositoryCount = this.contentGrid.dataSource.totalCount()
            })
        }

        if (locationEquipment != null) {
            this.inventory = locationEquipment
        }
    }


    private onContentGridSelectionChanged(): void {
        this.selectedDevices = this.contentGrid.selectedItems.map((equipment: OpLocationEquipment) => equipment.device)

        this.toggleConfigurationButtons()
    }

    private setContentGrid(): void {
        this.$scope.contentGridOptions = null

        this.$timeout(() => {
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__CONTENT_GRID_PARAMS, this.moduleName, {
                    groupReferenceType: Enums.ReferenceType.IdDistributor,
                    groupReferenceValue: this.userSession.getLoggedOperator().idDistributor,
                    viewReferenceType: Enums.ReferenceType.SerialNbr
                })
                .then((columns: ColumnModel[]) => {
                    this.$scope.contentGridOptions = {
                        addCustomFilters: true,
                        columnsDictionary: columns,
                        contextMenuItems: (isTouchScreen: boolean = false) => this.getContentGridContextMenuItems(),
                        localStorageVarForSavedEntity: 'deviceDepository',
                        name: "DepositoryContentGrid",
                        needCustomFilter: true,
                        type: GridTypes.PAGINATED_SMALL,
                        getDataSourceMethod: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                            return this.userSession
                                .getDataProvider()
                                .Depository
                                .getDepositoryContentFilter(this.referenceObject.idLocation, columns, pageNbr, pageSize, customWhereClause)
                        },

                        allowColumnReordering: !this.userSession
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DepositoryState),

                        buttonsOptions: {
                            enabled: true,
                            isRefreshButonHidden: true
                        },

                        dataSourceParser: this.depositoryService.getLocationEquipmentParser(),

                        onInitialized: (e: any, grid: GridController<OpLocationEquipment>) => {
                            this.contentGrid = grid
                        },

                        onDataReady: (equipment: OpLocationEquipment[]) => this.onContentGridDataReady(equipment),
                        onSelectionChanged: () => this.onContentGridSelectionChanged()
                    }
                });
        }, 100)
    }

    private getContentGridContextMenuItems(): any[] {
        const items: any[] = []

        if (this.userSession.getLoggedOperator().hasPermission(Activity.ACTION_RUN)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RunActions), ConfigHelper.Icon.RUN_ACTIONS, this.userSession),

                onItemClick: (e: any) => {
                    e.event.stopPropagation()
                    this.$scope.needActionRun = true
                    this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)

                    const selecteRows: any[] = this.contentGrid.dxGrid.getSelectedRowsData()

                    ActionRunController
                        .openActionPopup(this.$scope, this.$timeout, this.userSession.getDataProvider(), selecteRows, Enums.ReferenceType.SerialNbr, this.$scope.ACTION_RUN_POPUP_ID)
                        .fail((error: string) => {
                            if (error != null) {
                                CommonHelper.openInfoPopup(error, 'error', 4000)
                            }
                        })
                        .always(() => {
                            this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                        })
                }
            })
        }
        if (this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_EDIT_ALWAYS_INCLUDE_DEPOSITORY_ELEMENT_OP)) {
            const dynamicValueToCheck: string = 'DE_10302_0'
            if (this.isContexMenuVisible(dynamicValueToCheck, false)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UseAgain), ConfigHelper.Icon.AUTO_RENEW, this.userSession),

                    onItemClick: (e: any) => {
                        e.event.stopPropagation()
                        if (this.$scope.RE_USE_CONFIRMATION_POPUP_ID != null) {
                            this.$scope.$broadcast(
                                EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.RE_USE_CONFIRMATION_POPUP_ID,
                                LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AreYouSureToUseAgain)
                            )
                        }
                    }
                })
            }
        }
        return items
    }

    private isContexMenuVisible(value: string, shouldContexMenuBeVisible: boolean): boolean {
        let isUseAgainContexMenuVisible: boolean = shouldContexMenuBeVisible
        if (this.contentGrid.selectedItems != null && this.contentGrid.selectedItems.length > 0) {
            for (let j = 0; j < this.contentGrid.selectedItems.length; j++) {
                let isFound: boolean = false
                const locationEquipment: OpLocationEquipment = this.contentGrid.selectedItems[j]
                if (locationEquipment != null && locationEquipment.device != null && locationEquipment.device.dynamicValues != null && locationEquipment.device.dynamicValues.length > 0) {

                    for (let i = 0; i < locationEquipment.device.dynamicValues.length; i++) {
                        const dynamicValue: any = locationEquipment.device.dynamicValues[i]
                        if (dynamicValue.Key === value) {
                            isFound = true
                            isUseAgainContexMenuVisible = dynamicValue.Value
                            break
                        }
                    }
                    if (!isFound) {
                        isUseAgainContexMenuVisible = false
                        break
                    } else if (isFound && isUseAgainContexMenuVisible === false) {
                        break
                    }


                } else {
                    isUseAgainContexMenuVisible = false
                    break
                }
            }
        }
        return isUseAgainContexMenuVisible
    }

    //#endregion


    //#region Min States

    private initializeMinStates(depository: OpLocation): void {
        this.depository = depository
        this.initializeMinStateGrid(depository)
        this.initializeMinStateGridEdit()
    }

    private initializeMinStateGrid(depository: OpLocation): void {
        if (this.minStatesGrid != null) {
            this.minStatesGrid.setDataSource(this.depositoryMinStatesService.createMinStateItems(depository))
        } else {
            this.depositoryMinStatesService
                .createMinStateItems(depository)
                .then((articleItems: MinStateItem[]) => {
                    this.minStateGridOptions = {
                        addCustomFilters: true,
                        columnsDictionary: this.depositoryMinStatesService.getDepositoryMinStatesGridColumns(),
                        name: this.MIN_STATE_GRID_NAME,
                        needCustomFilter: true,
                        type: GridTypes.PAGINATED_SMALL,

                        allowColumnReordering: !this.userSession
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DepositoryMinStates),

                        buttonsOptions: {
                            enabled: true,
                            isRefreshButonHidden: true
                        },

                        dataSource: articleItems,

                        onDataReady: (minStateItems: MinStateItem[]) => this.onMinStatesGridDataReady(minStateItems),

                        onInitialized: (e: any, grid: GridController<any>) => {
                            this.minStatesGrid = grid
                        },

                    }
                })
        }
    }

    private onMinStatesGridDataReady(minStateItems: MinStateItem[]): void {
        this.minStatesCount = _.size(minStateItems)
    }

    private initializeMinStateGridEdit(): void {

        if (this.minStateGridEditOptions == null) {
            $.when<any>(
                this.depositoryMinStatesService.getArticlesGridEditData(),
                this.depositoryMinStatesService.createMinStateItems(this.depository)
            )
                .then((availableArticlesGridObject: any[], minStateGridObjects: MinStateItem[]) => {
                    this.minStateGridEditOptions = {
                        allowDublicatedRow: false,
                        columns: this.depositoryMinStatesService.getDepositoryMinStatesGridEditColumns(),
                        data: availableArticlesGridObject,
                        id: this.referenceObjectId,
                        items: minStateGridObjects,
                        name: this.MIN_STATE_GRID_EDIT_NAME,
                        popupId: this.MIN_STATE_GRID_EDIT_POPUP_ID,
                        title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MIN_STATES_EDITING, this.moduleName),
                        onCellPrepared: (options: any) => {
                            this.onEditMinStateCellPrepared(options)
                        },

                        allowColumnReordering: !this.userSession
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DepositoryMinStates),

                        onBeforeAdd: (minStateGridObject: MinStateItem) => {
                            return this.onEditMinStateBeforeAdd(minStateGridObject)
                        },

                        onSubmit: (added: any[], removed: any[], grid: any) => {
                            return this.onEditMinStateSubmit(added, removed, grid)
                        }
                    }
                })
        }

    }

    private onEditMinStateCellPrepared(options: any): void {
        this.depositoryMinStatesService.getEditIconInCell(options, this.DEPOSITORY_MIN_STATE_COLUMN_NAME)
    }

    private onEditMinStateBeforeAdd(minStateGridObject: MinStateItem): MinStateItem {
        const minStateGridObjectClone = TypeHelper.clone(minStateGridObject)

        minStateGridObjectClone.amount = 1

        return minStateGridObjectClone
    }

    private onEditMinStateSubmit(added: any[], removed: any[], grid: any): ng.IPromise<boolean> {
        const deferred = this.$q.defer<boolean>()

        this.depositoryMinStatesService
            .saveGridEditResult(this.depository, added, removed, grid)
            .then((savedDepository: OpLocation) => {
                this.onRefresh(savedDepository)

                this.depositoryMinStatesService
                    .createMinStateItems(savedDepository)
                    .then((minState: MinStateItem[]) => {
                        this.minStateGridEditOptions.items = minState
                        deferred.resolve(true)
                    })
            })
            .fail((error: any) => {
                this.logger.log(error)
                deferred.resolve(false)
            })

        return deferred.promise
    }

    private onMinStatesEdit(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.MIN_STATE_GRID_EDIT_POPUP_ID, 'depositoryMinState')
    }

    // #endregion


    // #region Setup

    getAccordions(): DetailsAccordion[] {
        const accordions: DetailsAccordion[] = []
        let items: DetailsAccordionSection[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryParameters)) {
            items.push({
                name: this.DEPOSITORY_PARAMS_ACCORDION_NAME,
                showInTab: this.DEPOSITORY_COMMON_TAB_NAME,
                showStatus: false,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryParameters),

                editMethod: () => this.onParamsEdit(),
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 0, items))
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryMinStates, true)) {
            items = []

            items.push({
                name: this.DEPOSITORY_MINIMUM_STATE_ACCORDION_NAME,
                showInTab: this.DEPOSITORY_COMMON_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MIN_STATES, this.moduleName),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryMinStates, true),

                editMethod: () => this.onMinStatesEdit(),
                status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount) + this.minStatesCount,
                onHidden: () => {
                    this.refreshMap()
                }
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 1, items))
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryState)) {
            items = []

            items.push({
                name: this.DEPOSITORY_CONTENT_ACCORDION_NAME,
                showInTab: this.DEPOSITORY_COMMON_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONTENT, this.moduleName),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryState),

                editMethod: () => this.openRewarehousingItemSwapper(),
                status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledCount) + this.devicesInDepositoryCount,
                onHidden: () => {
                    this.refreshMap()
                },

            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 2, items))
        }
        return accordions
    }


    private getActions(): DevExpress.ui.dxButtonOptions[] {
        const actions: DevExpress.ui.dxButtonOptions[] = []

        if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_CONFIGURATION_CONSISTENCY_CHECK_OP)) {
            actions.push({
                disabled: true,
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistencyCheck), ConfigHelper.Icon.ACTIONS, this.userSession),
                hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistencyCheck),
                width: '100%',

                onInitialized: (e: any) => {
                    this.configurationConsistencyCheckButton = e.component

                    this.toggleConfigurationButtons()
                },

                onClick: (e: any) => this.onGetDeviceConfigurationInconsistency(e)
            })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_CONFIGURATION_SEND)) {
            actions.push({
                disabled: true,
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice), ConfigHelper.Icon.DEVICES, this.userSession),
                hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),
                width: '100%',

                onInitialized: (e: any) => {
                    this.sendConfigurationToDeviceButton = e.component

                    this.toggleConfigurationButtons()
                },

                onClick: (e: any) => this.onSendDeviceConfiguration(e),
            })
        }

        return actions
    }

    getTabs(): any[] {
        const tabs: any[] = []

        if (
            !this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryParameters)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryMinStates)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryState)
        ) {
            tabs.push({
                template: TemplateHelper.getIconWithText(
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common),
                    ConfigHelper.Icon.HOME,
                    this.userSession
                ),

                name: this.DEPOSITORY_COMMON_TAB_NAME
            })
        }

        return tabs
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }

        this.$scope.reUseConfirmation = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UseAgain),

            onConfirmed: () => this.onConfirmUseAgain()
        }
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            actions: this.getActions(),
            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DEL) ? Activity[Activity.DEPOSITORY_DEL] : null,
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),
            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),

            deleteMethod: () => this.onDelete(),
            getAccordionDataMethod: () => this.getAccordionData(),
            getAccordionSelectionMethod: () => this.getAccordionSelection(),
            updateAccordionMethod: (names: any[]) => {
                this.updateAccordions(names)

                if (this.depositoryParametersComponent != null) {
                    setTimeout(() => { //there is 100ms timeout for showing accordion (common.details). need to wait for them
                        this.depositoryParametersComponent.refresh()
                    }, 200)
                }
            },
        }
    }

    private setInfoPopup(): void {
        this.$scope.infoPopupSource = {
            infoText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistent),
            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistencyCheck),
        }
    }

    private setTemplateConsts(): void {
        this.$scope.ACTION_RUN_POPUP_ID = this.$scope.detailsPopupId + '_ACTION_RUN_POPUP'
        this.$scope.ACTION_STATUS_POPUP_ID = this.$scope.detailsPopupId + '_ACTION_STATUS_POPUP'
        this.$scope.INFO_POPUP_ID = this.$scope.detailsPopupId + '_INFO_POPUP'
        this.$scope.ITEM_SWAPPER_POPUP_ID = this.$scope.detailsPopupId + '_ITEM_SWAPPER_POPUP'
        this.$scope.DELETE_CONFIRMATION_POPUP_ID = this.$scope.detailsPopupId + '_DELETE_CONFIRMATION_POPUP'
        this.$scope.RE_USE_CONFIRMATION_POPUP_ID = this.$scope.detailsPopupId + '_RE_USE_CONFIRMATION_POPUP'
    }

    // #endregion
}
